"use client";
import Image from "next/image";
import React from "react";
import type { StoryBlockProps } from "./StoryBlock";
import { useStoryBlock } from "../../utils/storyblock/useStoryBlock";

export default function StoryBlock(props: Readonly<StoryBlockProps>) {
  const hook = useStoryBlock(props);

  const {
    isInfluencersOrigin,
    isLiveOrigin,
    posterUrl,
    isMobile,
    containerClasses,
    influencersSectionClassName,
    liveSectionStyle,
    influencersContainerStyle,
    liveContainerStyle,
    influencersStoryblockStyle,
    liveStoryblockStyle,
    blockHeight,
    storyBlockRef,
  } = hook;

  const { title = "Story-Block", className = "" } = props;
  let containerStyle = undefined;
  if (isInfluencersOrigin) {
    containerStyle = influencersContainerStyle;
  } else if (isLiveOrigin) {
    containerStyle = liveContainerStyle;
  }

  let storyblockStyle = undefined;
  if (isInfluencersOrigin) {
    storyblockStyle = influencersStoryblockStyle;
  } else if (isLiveOrigin) {
    storyblockStyle = liveStoryblockStyle;
  }

  return (
    <section
      className={isInfluencersOrigin ? influencersSectionClassName : `fw-story-block ${className}`}
      data-cmp="StoryBlock"
      data-cmp-type="static"
      aria-label={title}
      style={isLiveOrigin ? liveSectionStyle : undefined}
    >
      {isLiveOrigin && posterUrl ? (
        <div
          aria-hidden="true"
          className={`pointer-events-none absolute inset-0 flex items-center justify-center p-4 ${
            isMobile ? "z-10" : "z-0"
          }`}
        >
          <Image
            src={posterUrl}
            alt=""
            width={800}
            height={1200}
            priority
            unoptimized
            className="h-full max-h-full w-auto max-w-full rounded-[10px] object-cover"
          />
        </div>
      ) : null}
      <div
        ref={isInfluencersOrigin || isLiveOrigin ? storyBlockRef : undefined}
        className={containerClasses}
        style={containerStyle}
      >
        {React.createElement("fw-storyblock", {
          key: blockHeight,
          className: "fw-story-block",
          style: storyblockStyle,
          ...hook.storyblockAttrs,
        })}
      </div>
    </section>
  );
}
